import axios from "../../axiosConfig/axios";
import { useQuery, useMutation } from "react-query";
const sendRFI = async (data) => {
    let body = {
        suppliers: data.suppliers,
        rfqId: data.rfqId
    }
    const { success } = await axios.post('rfi',body,{
        headers: {
            Authorization: data.token
        }
    })
    return success
}
export default {
    getRfq(callback,userToken,isAdmin=false,id=null,detailed =false,status=null){
        let url = '/rfq'
        let count = 0
        if(isAdmin){
            url += '?isAdmin=true'
            count += 1
        }
        if(id){
            url += count > 0 ? '&' : '?'
            url += `rfqId=${id}`
            count += 1
        }
        if(status){
            url += count > 0 ? '&' : '?'
            url += `status=${status}`
            count += 1
        }
        if(detailed){
            url += count > 0 ? '&' : '?'
            url += `detailed=true`
        }
        axios.get(url,{
            headers: {Authorization: userToken}
        }).then(res=>{
            callback(null,res.data)
        }).catch(error=>{
            callback({
                message : error
            },null)
        })
    },
    generateRFQ(file,token,isAdmin,onUploadProgress,callback){
        const formData = new FormData();
        formData.append("document", file);
        let params = {}
        if(isAdmin){
            params.isAdmin = true
        }
        axios.post('rfq',formData,{
            params: params,
            headers: {
                "content-type": "multipart/form-data",
                Authorization: token
            },
            onUploadProgress: onUploadProgress
        }).then(res => {
            callback(null,res.data.rfq)
        }).catch(error => {
            callback({
                message : error
            },null)
        })
    },
    updateRFQ(rfqId,data,token,callback){
        axios.patch(`rfq?isAdmin=true`,data,{
            params: {
                rfqId: rfqId
            },
            headers: {
                Authorization: token
            }
        }).then(res=>{
            callback(null,res.data)
        }).catch(error=>{
            callback({
                message : error
            },null)
        })
    },
    getPDF(id,token,callback){
        axios.get(`rfq/download?rfqId=${id}`,{
            responseType: 'arraybuffer',
            headers: {Authorization: token}
        }).then(response =>
        (response.status === 200? response.data : null))
        .then(pdfdata => {
            var len = pdfdata.length;
            var bytes = new Uint8Array( len );
            for (var i = 0; i < len; i++){
                bytes[i] = pdfdata.charCodeAt(i);
            }
            callback(pdfdata)
        })
    },
    useSendRFI() {
        return useMutation((data) => {
            return sendRFI(data)
        })
    }
}